import { confirmAlert } from 'react-confirm-alert';
import { reactLocalStorage } from 'reactjs-localstorage';
import { Store } from 'react-notifications-component';
import Moment from 'moment';

import Const from './Constants';
import Display from './Display';
import ReactDOM from 'react-dom';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
class Util {

  static serverStringDateTimeToDate = from => {
    if (!from || from === '' || from === '0000-00-00 00:00:00') return null;
    return Moment.utc(from, 'YYYY-MM-DD HH:mm:ss').toDate();
  };

  static dateToServerDateTime = from => {
    return Moment(from).utc().format('YYYY-MM-DD HH:mm:ss');
  };

  static dateToServerDate = from => {
    return from.format('YYYY-MM-DD');
  };

  static dateToDisplayDateTime = from => {
    return Moment(from).format('DD-MM-YYYY hh:mm:ss a');
  };

  static serverStringToDisplayDateTime = from => {
    if (!from || from === '' || from === '0000-00-00 00:00:00') return '-';
    return Moment(Moment.utc(from, 'YYYY-MM-DD HH:mm:ss').toDate())
      .format('DD-MM-YYYY hh:mm A');
  };

  static serverStringToDisplayTime = from => {
    if (!from) return '-';
    const date = Util.serverStringDateTimeToDate(from);
    return Moment(date).format('hh:mm A');
  };

  static serverStringToDisplayDate = from => {
    if (!from || from === '' || from === '0000-00-00 00:00:00') return '-';
    const date = Util.serverStringDateTimeToDate(from);
    return Moment(date).format('DD-MM-YYYY');
  };

  static dateToDisplayDate = from => {
    return Moment(from).format('DD-MM-YYYY');
  };

  static dateToDisplayMonth = from => {
    return Moment(from).format('MMM-YYYY');
  };

  static dateToDisplayDay = from => {
    return Moment(from).format('DD-MMM');
  };

  static dateToDisplayHr = from => {
    return Moment(from).format('hh A');
  };

  static binaryToDecimal = binary => parseInt(binary, 2);
  static decimalToBinary = decimal => Number(decimal ? decimal : 0).toString(2);

  static confirmAlert = (title, message, lbOk, lbCancel, action) => {
    confirmAlert({
      title: title,
      message: message,
      buttons: [
        { label: lbOk, onClick: action },
        { label: lbCancel }
      ]
    });
  };

  static showError = message => Util.showNotification('Failure', message, 'danger');

  static showNotification = (title, message, type, onClick) => {
    Store.addNotification({
      title: title,
      message: message,
      type: type,
      insert: 'top',
      container: 'top-right',
      animationIn: ['animate__animated', 'animate__fadeIn'],
      animationOut: ['animate__animated', 'animate__fadeOut'],
      dismiss: onClick ? undefined : { duration: 5000, pauseOnHover: true, onScreen: true },
      onRemoval: (id, removedBy) => removedBy === 'click' && onClick ? onClick() : null,
      showIcon: false
    });
    if (onClick) {
      new Audio('/audio/alert.mp3').play()
        .then(() => {})
        .catch(err => console.log("Failed to play notification alert sound: ", err));
    }
  };

  static isMandatory = value => {
    return value !== undefined && value != null && value.includes(Const.Mandatory);
  };

  static isEmpty = value => {
    return value === undefined || value === null || value.trim() === '';
  };

  static isAllow = (permission, check) => {
    const binary = Util.decimalToBinary(permission);
    const index = binary.length - 1 - check;
    return 0 <= index && index < binary.length ? parseInt(binary[index]) === Const.True : Const.False;
  };
  static apochToDisplayDateTime = from => Moment(new Date(from)).format('DD-MM-YYYY hh:mm A');
  static failure = (res, module) => {
    if (!res) return "Error";
    const keys = Object.keys(res);
    let message = '';
    for (let i = 0; i < keys.length; i++) {
      if (module && module.fields[keys[i]]) {
        message += `${message !== '' ? '=>' : ''} ${module.fields[keys[i]].label_name} : ${res[keys[i]]}`;
      } else {
        message += `${message !== '' ? '=>' : ''} ${keys[i]} : ${res[keys[i]]}`;
      }
    }
    return message;
  };

  static templateToData = (template, model, fields, onlyText) => {
    const values = [];
    while (template.includes('${')) {
      const start = template.indexOf('${');
      const end = template.indexOf('}', start);
      const inField = template.substring(start, end + 1);
      let value = '';
      if (inField.includes('.')) {
        const field = template.substring(start + 2, end).split('.');
        let from = model;
        let fromField = field[1];
        let fromFields = fields;

        let module = reactLocalStorage.getObject(Const.Model);
        module = module[field[0]];
        if (module.options) {
          let otherField = Object.keys(fields).find(key => fields[key].field_type
            .includes(Const.Opt + field[0]));
          otherField = fields[otherField];
          let val = model[otherField.field_key];
          val = val.includes(Const.Opt) ? val.substring(1).split(Const.Opt)[0] : val;
          val = parseInt(val);
          from = module.options.find(opt => opt.id === val);
          fromFields = module.fields;
        }
        value = Display.FieldValue(from, fromField, fromFields, onlyText);
      } else {
        const field = template.substring(start + 2, end);
        value = Display.FieldValue(model, field, fields, onlyText);
      }
      values.push(value);
      template = template.replace(inField, value);
    }
    return { template, values };
  };

  static templateToDataInObject = (template, model, fields) => {
    if (template && typeof template == 'string') {
      const temp = Util.templateToData(template, model, fields);
      template = temp.template;
    } else if (template && typeof template == 'object' && Array.isArray(template)) {
      for (let i = 0; i < template.length; i++) {
        template[i] = Util.templateToDataInObject(template[i], model, fields);
      }
    } else if (template && typeof template == 'object') {
      const keys = Object.keys(template);
      for (let i = 0; i < keys.length; i++) {
        const key = Util.templateToData(keys[i], model, fields);
        const value = Util.templateToDataInObject(template[keys[i]], model, fields);
        template[key.template] = value;
      }
    }
    return template;
  };

  static serverImport = (from, format) => {
    const date = Moment(from, format).utc().format('YYYY-MM-DD HH:mm:ss');
    return date !== 'Invalid date' ? date : '';
  };

  static round = (number, decimal) => Math.round(number * Math.pow(10, decimal)) / Math.pow(10, decimal);

  static toTextFromNumber = (value) => {
    if (!value) return '-';

    const [intStr = '', decStr = ''] = (typeof value === "string" ? value : `${value}`).split('.');
    let n = parseInt(intStr || '0', 10);
    if (Number.isNaN(n)) return '';

    const units = [
      [10000000, 'Cr'],
      [100000, 'Lc'],
      [1000, 'Th'],
      [100, 'H'],
    ];

    let text = '';
    for (const [size, label] of units) {
      if (n >= size) {
        const q = Math.floor(n / size);
        text += `${q}${label} `;
        n -= q * size;
      }
    }

    // show the decimal part only if it has a non-zero digit
    const hasDecimal = /[1-9]/.test(decStr);

    if (hasDecimal) {
      text += `${n}.${decStr}`;
    } else if (n > 0) {
      text += `${n}`;
    }

    return text;
  }

  static getLatLngFromAddress = async (address, apiKey) => {
    if (!address || !apiKey) {
      return;
    }
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`;

    const response = await fetch(url);
    const data = await response.json();

    if (data.status === "OK") {
      const { lat, lng } = data.results[0].geometry.location;
      return { lat, lng };
    } else {
      return;
    }
  };

  static showReminders = (title, message, onClick) => {
    new Audio("/audio/alert.mp3").play().catch(err => console.log('Audio play failed:', err));
    this.showModalNotification(title, message, onClick);
  };

  static showModalNotification(title, message, onClick) {
    // Remove existing modal root if any
    const existing = document.getElementById('notification-modal-root');
    if (existing) {
      existing.remove();
    }

    // Create a container div
    const modalRoot = document.createElement('div');
    modalRoot.id = 'notification-modal-root';
    document.body.appendChild(modalRoot);

    // Cleanup function
    const cleanup = () => {
      ReactDOM.unmountComponentAtNode(modalRoot);
      modalRoot.remove();
    };

    // Modal component
    const NotificationModal = () => {
      const [show, setShow] = React.useState(true);

      const handleClose = () => {
        setShow(false);
      };

      const handleExited = () => {
        cleanup();
      };

      const handleView = () => {
        if (onClick) onClick();
        setShow(false);
      };

      return (
        <Modal
          show={show}
          onHide={handleClose}
          onExited={handleExited}
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-bell text-primary mr-2"></i>
              Reminder
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4 className="mb-2">{title}</h4>
            <h6 className="text-muted mb-0 small">{message}</h6>
          </Modal.Body>
          <Modal.Footer className="py-2">
            <Button size="sm" variant="secondary" onClick={handleClose}>
              Dismiss
            </Button>
            {onClick && (
              <Button size="sm" variant="primary" onClick={handleView}>
                View
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      );
    };

    // Render modal into the container
    ReactDOM.render(<NotificationModal />, modalRoot);
  }

  static BASE62 = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  /* eslint-env es2020 */
  static generateShortId(clientId, propertyId) {
    const combined = BigInt(clientId) * 1_000_000n + BigInt(propertyId);
    return this.encodeBase62(Number(combined));
  }
  static encodeBase62(num) {
    let encoded = '';
    while (num > 0) {
      encoded = this.BASE62[num % 62] + encoded;
      num = Math.floor(num / 62);
    }
    return encoded || '0';
  }

  static formatINRCurrency = (value, options = { showCurrencyPrefix: true }) => {
    if (value === null || value === undefined || value === '' || value == 0) return '-';

    const number = Number(value);
    if (isNaN(number)) return '-';

    return new Intl.NumberFormat('en-IN', {
      ...(options?.showCurrencyPrefix ? { currency: 'INR', style: 'currency' } : {}) ,
      minimumFractionDigits: options.decimals ?? 0,
      maximumFractionDigits: options.decimals ?? 2,
    }).format(number);
  };
}
export default Util;